import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-inspection-details',
  templateUrl: './inspection-details.component.html',
  styleUrls: ['./inspection-details.component.css']
})
export class InspectionDetailsComponent implements OnInit {

  @Input() data;

  constructor() { }

  ngOnInit(): void {
  }

}
